import { render, staticRenderFns } from "./MotivoDescuento.vue?vue&type=template&id=478ba500"
import script from "./MotivoDescuento.vue?vue&type=script&lang=js"
export * from "./MotivoDescuento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports